import { useNavigate, useParams } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { tags } from "@/mocks/tags";
import { videos } from "@/mocks/videos";
import VideoBrowser from "@/components/feature/VideoBrowser";
import Breadcrumb from "@/components/feature/Breadcrumb";
import EmptyState from "@/components/base/EmptyState";

export default function TagPage() {
  const navigate = useNavigate();
  const { tagSlug } = useParams();
  const tag = tags.find((item) => item.slug === tagSlug);

  useDocumentTitle(
    tag ? `${tag.name}视频 - 啪啪视频` : "视频标签 - 啪啪视频",
    tag
      ? `${tag.description} 在啪啪视频发现更多与${tag.name}相关的高清视频内容。`
      : "在啪啪视频按标签浏览高清视频资源。",
    tag ? `${tag.name}视频,${tag.name},在线视频,啪啪视频` : "视频标签,高清视频,在线视频,啪啪视频",
  );

  if (!tag) {
    return (
      <div className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-6">
        <EmptyState
          icon="ri-price-tag-3-line"
          title="没有找到这个标签"
          description="该标签可能已下线或链接有误。你可以返回首页，浏览其他热门标签下的视频。"
          actionLabel="返回首页"
          onAction={() => navigate("/")}
        />
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "标签" }, { label: tag.name }]} />

      <header className="mt-4 flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-6 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-4">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50">
            <i className="ri-price-tag-3-fill text-2xl"></i>
          </span>
          <div>
            <h1 className="font-heading text-2xl font-bold text-foreground-950">{tag.name}视频</h1>
            <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-foreground-500">{tag.description}</p>
          </div>
        </div>
        <span className="w-fit rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
          {videos.filter((video) => video.tags.includes(tag.slug)).length} 个视频
        </span>
      </header>

      <div className="mt-6">
        <VideoBrowser
          videos={videos}
          lockedFilter={{ tag: tag.slug }}
          showCategory
          showTag={false}
          emptyTitle="该标签下暂无符合条件的视频"
          emptyDescription="试着更换分类，或放宽地区、时间与时长筛选条件。"
        />
      </div>
    </div>
  );
}